import {immerable} from "immer";
import BuildingCreationModel from "./building-creation-model.ts";

class ProjectCreationModel {
    [immerable] = true;

    name = "";

    localisationId = -1;

    buildings: BuildingCreationModel[] = [];

    setName(name: string) {
        this.name = name;
    }

    setLocalisationId(localisationId: number) {
        this.localisationId = localisationId;
    }

    setBuildings(buildings: BuildingCreationModel[]) {
        this.buildings = buildings;
    }
}

export default ProjectCreationModel;
